import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { getIssuesComponent, getErrorIssues, getWarningIssues } from '../../../../../../../utils/validationSummary';
import Radio from 'components/shared/StandaloneRadio';
import { withTranslation } from 'react-i18next';

class ReworkKeyForm extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            keys: this.getKeys(!isNaN(props.property) ? props.property : 0, props.numberOfKeys),
            type: props.type,
            propertyObject: props.propertyObject,
            propertyObjectS: props.propertyObjectS,
            reworkKeySelected: "default",
            reworkKey: {
                target: {
                    name: 'reworkKey',
                    value: props.propertyObject.value,
                    reworkKeyType: "default"
                }
            },
            newReworkKey: props.property
        };

        this.props.handleChange(this.state.reworkKey);

        this.getKeys = this.getKeys.bind(this);
        this.handleChangeReworkKeySelected = this.handleChangeReworkKeySelected.bind(this);
        this.handleChangeMasterKeyType1 = this.handleChangeMasterKeyType1.bind(this);
        this.handleChangeMasterKeyType2 = this.handleChangeMasterKeyType2.bind(this);
    }

    handleChangeReworkKeySelected(e) {
        this.setState({ reworkKeySelected: e.target.name });

        const reworkKey = this.state.reworkKey;

        if(this.props.selectedMode === "master"){
            reworkKey.target.value = e.target.name === "reworkKey" ? this.state.newReworkKey : this.state.propertyObject.value;
        } else if (this.props.selectedMode === "service"){
            reworkKey.target.value = e.target.name === "reworkKey" ? this.state.newReworkKey : this.state.propertyObjectS.value;
        }

        reworkKey.target.reworkKeyType = e.target.name

        this.setState({ reworkKey: reworkKey });

        this.props.handleChange(reworkKey);

    }

    handleChangeMasterKeyType1(e) {
        const value = e.target.value;

        if(value > 9999){
            return
        }

        const reworkKey = this.state.reworkKey;
        if(this.props.selectedMode === "master"){
            reworkKey.target.value = this.state.reworkKeySelected === "reworkKey" ? value : this.state.propertyObject.value;
        } else if (this.props.selectedMode === "service"){
            reworkKey.target.value = this.state.reworkKeySelected === "reworkKey" ? value : this.state.propertyObjectS.value;
        }

        this.setState({ reworkKey: reworkKey });

        this.setState({ newReworkKey: value });

        this.props.handleChange(reworkKey);
    }

    handleChangeMasterKeyType2(e) {
        const value = parseInt(e.target.value ? e.target.value : 0);
        const index = e.target.name;
        this.setState(prevState => {
            const keys = prevState.keys;
            keys[index] = value;

            return {
                keys: keys
            };
        }, () => {

            const number = this.getPasswordFromInputs();

            const reworkKey = this.state.reworkKey;
            if(this.props.selectedMode === "master"){
                reworkKey.target.value = this.state.reworkKeySelected === "reworkKey" ? number : this.state.propertyObject.value;
            } else if (this.props.selectedMode === "service"){
                reworkKey.target.value = this.state.reworkKeySelected === "reworkKey" ? number : this.state.propertyObjectS.value;
            }

            this.setState({ reworkKey: reworkKey });

            this.setState({ newReworkKey: number });

            this.props.handleChange(reworkKey);
        });
    }

    getKeys(value, numberOfKeys) {
        let keys = [];
        for (let i = 0; i < numberOfKeys; i++) {
            keys.push(this.getSplitByNumber(value, i));
        }
        return keys;
    }

    getSplitByNumber(number, index) {
        return ((number & (255 << (index * 8))) >>> (index * 8));
    }

    getPasswordFromInputs() {
        let value = 0;
        for (let i = 0; i < this.props.numberOfKeys; i++) {
            value |= this.state.keys[i] << (i * 8);
        }
        return value >>> 0;
        //return ((index3 << 24) | (index2 << 16) | (index1 << 8) | (index0 << 0)) >>> 0;
    }

    renderKeys(className) {
        const keysDiv = this.state.keys.map((key, i) => {
            const index = this.props.numberOfKeys - i - 1;

            let classNameValidated = this.state.keys[index] <= 255 ? className : className + ' danger';

            return (
                <Col sm="2" key={index} style={{ padding: "0 0.25rem" }}>
                    <input
                        disabled={this.props.disabled}
                        key={index}
                        className={classNameValidated}
                        name={index}
                        type="number"
                        min={0}
                        max={255}
                        value={this.state.keys[index]}
                        onChange={this.handleChangeMasterKeyType2} />
                </Col>
            );
        });

        return (
            <div style={{ display: "flex" }}>
                {keysDiv}
            </div>);
    }

    renderMasterKey(classNameParent) {
        switch (this.state.type) {
            case 1:

                const errors = getErrorIssues(this.props.issues, this.props.propertyObject);
                const warnings = getWarningIssues(this.props.issues, this.props.propertyObject);

                const className = `input-property-picker ${errors.length > 0 ? 'danger' : warnings.length > 0 ? 'warning' : ''}`;
                //OEM code
                return (
                    <div style={{ paddingRight: "0" }}>
                        <input
                            disabled={this.props.disabled}
                            className={className}
                            name={this.props.propertyObject.info.name}
                            type="number"
                            min={this.props.propertyObject.valueMeta.min}
                            max={this.props.propertyObject.valueMeta.max}
                            step={1}
                            value={this.state.newReworkKey ? this.state.newReworkKey : "0"}
                            onChange={this.handleChangeMasterKeyType1} />

                        {getIssuesComponent(errors, warnings)}
                    </div>
                );
            case 2:
                return this.renderKeys(classNameParent);
            default:
                break;
        }
    }

    render() {
        const errors = getErrorIssues(this.props.issues, this.props.property);
        const warnings = getWarningIssues(this.props.issues, this.props.property);

        const className = `input-property-picker ${errors.length > 0 ? 'danger' : warnings.length > 0 ? 'warning' : ''}`;
        const { t } = this.props;
        return (
            <div className="flex-column" style={{ paddingBottom: "0.75rem", paddingLeft: "2.5rem" }}>

                <Row style={{ margin: "0", paddingTop: "0.25rem" }}>
                    <Radio
                        disabled={this.props.disabled}
                        name="default"
                        checked={this.state.reworkKeySelected === "default"}
                        onClick={this.handleChangeReworkKeySelected}
                        onChange={this.handleChangeReworkKeySelected}
                    />
                    <Col style={{ display: "flex" }}>
                        <p style={{ margin: "auto 0" }}>
                            {this.props.selectedMode} key from project (Configuration Lock)
                        </p>
                    </Col>
                </Row>

                <Row style={{ margin: "0", paddingTop: "0.25rem" }}>
                    <Radio
                        disabled={this.props.disabled}
                        name="reworkKey"
                        checked={this.state.reworkKeySelected === "reworkKey"}
                        onClick={this.handleChangeReworkKeySelected}
                        onChange={this.handleChangeReworkKeySelected}
                    />
                    <Col>
                        <p style={{ margin: "0" }}>
                            {t(this.props.selectedMode)} {t('key')}:
                        </p>
                        {this.renderMasterKey(className)}
                    </Col>
                </Row>

                <Row>
                    {getIssuesComponent(errors, warnings)}
                </Row>
            </div>
        );
    };
}

const mapStateToProps = (state, ownProps) => {
    return {
        validationSummary: state.project.validationSummary,
        issues: state.project.issueByProperty,
    };
};

const mapDispatchToProps = {
}

export default compose(
    connect(
        mapStateToProps,
        mapDispatchToProps),
    withTranslation()
)(ReworkKeyForm);
